import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["v-if"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "pagestyle" }
const _hoisted_11 = { class: "dialog-footer" }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  const router = useRouter()
  const searchForm:any = reactive({
    supplierid:"",
    status:"",
    words:"",
    limit:10,
    page:1,
  })
  const form:any = reactive({
    id:'',
    sn:'',
    supplierId:'',
  })
  const baseData:any = reactive({
    loading:false,
    title:'',
    supplierList:[],
    showSupplierBox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.words = ""
    searchForm.status = ""
    getList()
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const showSupplier = (data:any) => {
    baseData.showSupplierBox = true
    form.id = data.id
    form.sn = data.sn
    form.supplierId = data.supplierid ? data.supplierid : ''
  }
  // const cancelReceive = (id) => {
  //   const loading = ElLoading.service({lock: true})
  //   api.orderApi.cancelReceive({id:id}).then((res:any)=>{
  //     loading.close()
  //     if(res.code==200){
  //       getList()
  //     }else{
  //       ElMessage.error(res.message)
  //     }
  //   })
  // }
  const getSupplierList = () => {
    api.supplierApi.alllist({}).then((res:any)=>{
      if(res.code==200){
        baseData.supplierList = res.data
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const setSupplier = () => {
    if(!form.id){
      ElMessage.error('请选择工单')
      baseData.showSupplierBox = false
      return false
    }
    if(!form.supplierId){
      ElMessage.error('请选择服务商')
      baseData.showSupplierBox = false
      return false
    }
    const loading = ElLoading.service({lock: true})
    api.orderApi.setSupplier(form).then((res:any)=>{
      loading.close()
      if(res.code==200){
        baseData.showSupplierBox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getList = () => {
    localStorage.setItem('orderspage',searchForm.page);
    localStorage.setItem('orderssupplierid',searchForm.supplierid);
    localStorage.setItem('ordersstatus',searchForm.status);
    localStorage.setItem('orderswords',searchForm.words);
    localStorage.setItem('orderslimit',searchForm.limit);
    baseData.loading = true
    api.orderApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.data
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const edit = (id:any) => {
    router.push("/workOrder/edit/"+id);
  }
  // const del = (id:number) => {
  //   baseData.loading = true
  //   api.supplierApi.del({id:id}).then((res:any)=>{
  //     baseData.loading = false
  //     if(res.code==200){
  //       ElMessage({
  //         message: res.message,
  //         type: 'success',
  //       })
  //       getList()
  //     }else{
  //       ElMessage.error(res.message)
  //     }
  //   })
  // }
  onMounted(() => {
    searchForm.page = localStorage.getItem('orderspage')&&localStorage.getItem('orderspage')!=null&&localStorage.getItem('orderspage')!='null' ? parseInt(localStorage.getItem('orderspage') ): 1;
    searchForm.supplierid = localStorage.getItem('orderssupplierid')&&localStorage.getItem('orderssupplierid')!=null&&localStorage.getItem('orderssupplierid')!='null' ? parseInt(localStorage.getItem('orderssupplierid')) : '';
    searchForm.status = localStorage.getItem('ordersstatus')&&localStorage.getItem('ordersstatus')!=null&&localStorage.getItem('ordersstatus')!='null' ? localStorage.getItem('ordersstatus') : '';
    searchForm.words = localStorage.getItem('orderswords')&&localStorage.getItem('orderswords')!=null&&localStorage.getItem('orderswords')!='null' ? localStorage.getItem('orderswords') : '';
    searchForm.limit = localStorage.getItem('orderslimit')&&localStorage.getItem('orderslimit')!=null&&localStorage.getItem('orderslimit')!='null' ? parseInt(localStorage.getItem('orderslimit')) : 10;
    console.log(localStorage.getItem('orderspage'))
    getSupplierList()
    getList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("工单列表")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: searchForm,
          inline: "",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "服务商" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: searchForm.supplierid,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.supplierid) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部",
                      value: ""
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.supplierList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.company,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: searchForm.status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部",
                      value: ""
                    }),
                    _createVNode(_component_el_option, {
                      label: "待接单",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "已接单",
                      value: "2"
                    }),
                    _createVNode(_component_el_option, {
                      label: "安装中",
                      value: "3"
                    }),
                    _createVNode(_component_el_option, {
                      label: "已完成",
                      value: "4"
                    }),
                    _createVNode(_component_el_option, {
                      label: "已驳回",
                      value: "8"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "关键词" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: searchForm.words,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.words) = $event)),
                  placeholder: "公司 | 联系人 | 手机号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: reset }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "sn",
              label: "工单编号",
              width: "190"
            }),
            _createVNode(_component_el_table_column, { label: "商品信息" }, {
              default: _withCtx((scope) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.goods, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_popover, {
                    key: index,
                    trigger: "click"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        style: {"float":"left","margin":"0 10px 10px 0"},
                        type: "primary",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.goods_name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(item.catagory_name), 1),
                        _createElementVNode("span", {
                          "v-if": item.goods_name
                        }, _toDisplayString(item.goods_name), 9, _hoisted_2),
                        _createTextVNode(" X " + _toDisplayString(item.number), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "联系人信息",
              width: "190"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", null, "联系人：" + _toDisplayString(scope.row.name), 1),
                _createElementVNode("div", null, "手机号码：" + _toDisplayString(scope.row.mobile), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "address",
              label: "联系人地址"
            }),
            _createVNode(_component_el_table_column, {
              prop: "supplier",
              label: "服务商",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "tag_price",
              label: "金额",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "transaction_id",
              label: "微信订单号",
              width: "260"
            }),
            _createVNode(_component_el_table_column, {
              prop: "addTime",
              label: "时间",
              width: "110"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "80"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, "待接单"))
                  : (scope.row.status == 2)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, "已接单"))
                    : (scope.row.status == 3)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "安装中"))
                      : (scope.row.status == 4)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "待核销"))
                        : (scope.row.status == 5)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, "已完成"))
                          : (scope.row.status == 6)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, "待评价"))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 6,
                                href: "javascrip:void(0)",
                                title: scope.row.refuseReason
                              }, "驳回", 8, _hoisted_9))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "180"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status < 3 || scope.row.status == 8)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      onClick: ($event: any) => (showSupplier(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("设置服务商")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (edit(scope.row.id)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.showSupplierBox,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((baseData.showSupplierBox) = $event)),
      title: "派发服务商(更改服务商，工单会变成待接单状态)"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (baseData.showSupplierBox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: setSupplier
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { model: form }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "订单编号",
              "label-width": "120"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(form.sn), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "服务商",
              "label-width": "120"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.supplierId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.supplierId) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "",
                      value: ""
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.supplierList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.company,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})